import { WorkoutCardDuration } from './workout-card-duration'
import { WorkoutCardTrainer } from './workout-card-trainer'
import React from 'react'
import { cn } from 'src/lib/utils'

interface WorkoutCardMetaProps {
  className?: string
}

export const WorkoutCardMeta = ({ className }: WorkoutCardMetaProps): React.ReactElement => {
  return (
    <div className={cn('flex items-center justify-between mt-2', className)}>
      <WorkoutCardTrainer />
      <WorkoutCardDuration />
    </div>
  )
}
